<template>
    <div style="margin-top: 5rem">
        <div>More Projects</div>
        <!--<div layout="row sm-column top-stretch">-->
            <!--<div v-for="project in list" >-->
                <!--<thumbnail v-bind="project"/>-->
            <!--</div>-->
        <!--</div>-->

        <div layout="row sm-column top-stretch">
            <div layout="row top-stretch">
                <div v-for="project in list[0]">
                    <thumbnail v-bind="project" />
                </div>
            </div>
            <div layout="row top-stretch">
                <div v-for="project in list[1]">
                    <thumbnail v-bind="project" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Thumbnail from "./Thumbnail";

    export default {
        name: "NextProjects",
        components: {Thumbnail},
        props: ['list']
    }
</script>

<style scoped>

</style>